import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'

const component = universal(() => import('./BookCairProfilePage'))

class AsyncBookCairProfilePage extends AsyncPage {
  nonav = true
  constructor() {
    super({
      title: 'navigation./book-cair',
      pageComponent: component,
      isChromeless: true,
    })
  }
}

export default new AsyncBookCairProfilePage()
